export default __webpack_public_path__ + "static/media/specialist.1149f203.png";